import { servicedeskKnowledgeBaseAppLinksResource } from '@jira/jira-service-desk-knowledge-base-resources/src/app-links/index.tsx';
import { servicedeskKnowledgeBaseKbTopicsResource } from '@jira/jira-service-desk-knowledge-base-resources/src/kb-topics/index.tsx';
import { servicedeskKnowledgeBaseAiDraftGenerateResource } from '@jira/jira-service-desk-knowledge-base-resources/src/ai-draft-generate/index.tsx';
import { servicedeskKnowledgeBaseFetchProjectIssuesResource } from '@jira/jira-service-desk-knowledge-base-resources/src/fetch-project-issues/index.tsx';
import { servicedeskKnowledgeBaseThirdpartyConnectorsResource } from '@jira/jira-service-desk-knowledge-base-resources/src/thirdparty-connectors/index.tsx';

import { fg } from '@atlassian/jira-feature-gating';
import { resourceWithCondition } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';

export const getKBExperimentResources = () => [
	resourceWithCondition(
		() => fg('jsm_kb_activation_experiment'),
		servicedeskKnowledgeBaseAppLinksResource,
	),
	resourceWithCondition(
		() => fg('jsm_kb_activation_experiment'),
		servicedeskKnowledgeBaseKbTopicsResource,
	),
	resourceWithCondition(
		() => fg('jsm_kb_activation_experiment'),
		servicedeskKnowledgeBaseAiDraftGenerateResource,
	),
	resourceWithCondition(
		() => fg('jsm_kb_activation_experiment'),
		servicedeskKnowledgeBaseFetchProjectIssuesResource,
	),
	resourceWithCondition(
		() => fg('jsm_kb_activation_experiment'),
		servicedeskKnowledgeBaseThirdpartyConnectorsResource,
	),
];
